module.exports = __webpack_public_path__ + "static/img/railway18.a66a8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/railway18.png
// module id = FcEb
// module chunks = 9